import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/commodity',
    name: 'commodity',
    component: () => import(/* webpackChunkName: "commodity" */ '../views/commodity.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "contactUs" */ '../views/service.vue')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import(/* webpackChunkName: "public" */ '../views/product.vue')
  },
  {
    path: '/shopping',
    name: 'shopping',
    component: () => import(/* webpackChunkName: "shopping" */ '../views/shopping.vue')
  },
  {
    path: '/medium',
    name: 'medium',
    component: () => import(/* webpackChunkName: "medium" */ '../views/medium.vue')
  },
  {
    path: '/shoppingCart',
    name: 'shoppingCart',
    component: () => import(/* webpackChunkName: "medium" */ '../views/shoppingCart.vue')
  },
  {
    path: '/OrderConfirm',
    name: 'OrderConfirm',
    component: () => import(/* webpackChunkName: "medium" */ '../views/OrderConfirm.vue')
  },
  {
    path: '/MyOrders',
    name: 'MyOrders',
    component: () => import(/* webpackChunkName: "medium" */ '../views/MyOrders.vue')
  },
  {
    path: '/logIn',
    name: 'logIn',
    component: () => import(/* webpackChunkName: "medium" */ '../views/logIn.vue')
  },
  {
    path: '/OrderDetail',
    name: 'OrderDetail',
    component: () => import(/* webpackChunkName: "medium" */ '../views/OrderDetail.vue')
  },
  {
    // 浏览记录
    path: '/browse',
    name: 'browse',
    component: () => import(/* webpackChunkName: "medium" */ '../views/browse.vue')
  },
  {
    // 搜索
    path: '/search',
    name: 'search',
    component: () => import(/* webpackChunkName: "medium" */ '../views/search.vue')
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router

// import { createRouter, createWebHashHistory } from 'vue-router'
// import routerM from './routerM'
// import routerPC from './routerPC'


// const ISMOBILE = function () {
//   let flag = navigator.userAgent.match(
//     /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
//   );
//   return flag;
// };
 
// const router = createRouter({
//   history: createWebHashHistory(),
//   routes: ISMOBILE() ? routerM : routerPC,
// })

// export default router

